export default __webpack_public_path__ + "static/media/logo-orofacial.cc18bb40.png";